import ApiService from './_api.service'
import { Client as Model } from '@/models/client.model'

const ClientService = {
    create: function(entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(process.env.VUE_APP_API_CLIENTS_URL, data)
    },

    read: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(
                    key => (queryParams += key + '=' + args[key] + '&')
                )
        }
        return ApiService.get(process.env.VUE_APP_API_CLIENTS_URL + queryParams)
    },

    update: async function(id, entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(
            process.env.VUE_APP_API_CLIENTS_URL + id + '/',
            data
        )
    },

    delete: async function(id) {
        return ApiService.delete(process.env.VUE_APP_API_CLIENTS_URL + id + '/')
    }
}

export default ClientService
export { ClientService }
